// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"6b29cb12","360":"412b8f10","580":"0029431d","720":"69ebfef6"}[chunkId] + ".chunk.css";
};